export default "/images/vendor/flag-icon-css/flags/4x3/ch.svg?7a52ef5e31b7f5e08a015cbcdc72e365";